import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PaymentMobileData, PaymentMobileFormData, ReferralCodeData } from '../models/referral-coupon.model';

@Injectable({
    providedIn: 'root',
})
export class ReferralService {
    private apiUrl = `${environment.API_URL}/referrals`;

    constructor(private http: HttpClient) {}

    /** Endpoint público: obtiene código de referido sin autenticación (usado en login/marketing). */
    public getReferralCode(tenantId: string): Observable<ReferralCodeData> {
        return this.http.post<any>(`${this.apiUrl}/code`, { tenantId }).pipe(map(response => response.data));
    }

    /** Endpoint privado: obtiene información completa de referidos del tenant autenticado (JWT requerido). */
    public getReferralInfo(): Observable<ReferralCodeData> {
        return this.http.get<any>(`${this.apiUrl}/me`).pipe(map(response => response.data));
    }

    /** Guarda o actualiza los datos de pago móvil del referidor autenticado. */
    public savePaymentMobile(data: PaymentMobileFormData): Observable<{ tenantId: string; paymentMobile: PaymentMobileData }> {
        return this.http.put<any>(`${this.apiUrl}/me/payment-mobile`, data).pipe(map(response => response.data));
    }
}
